// D:\my-website\src\utils\defaultContent.js

// 默认主页设置
export const defaultHomepageSettings = {
    heroTitle: "致力于提供高效、可靠的供应链解决方案。",
    heroDescription: "我们是广东合正国际供应链管理有限公司，专注于为全球客户提供一站式、端到端的供应链管理服务。",
    heroButtonText: "了解更多",
    heroBackgroundImageUrl: "https://placehold.co/1920x1080/007bff/ffffff?text=Default+Background+Image",
    logoUrl: "https://placehold.co/40x40/cccccc/333333?text=Logo",
    companyName: "广东合正国际供应链管理有限公司"
};

// 默认关于我们内容
export const defaultAboutUsContent = {
    aboutText1: "广东合正国际供应链管理有限公司，成立于XXXX年，总部位于中国，是一家致力于提供高效、可靠的全球供应链解决方案的创新型企业。我们凭借深厚的行业经验、专业的团队和先进的技术，为客户提供从采购、物流、仓储到分销的全方位服务。",
    aboutText2: "我们秉持“客户至上，诚信为本，创新发展，合作共赢”的经营理念，与全球合作伙伴紧密协作，构建了强大的供应链网络。我们的目标是成为客户最信赖的供应链伙伴，助力客户在全球市场中取得持续成功。",
    aboutImageUrl: "https://placehold.co/600x400/a7d9ff/007bff?text=About+Us+Image",
    teamIntro: "我们的团队由一群充满激情、经验丰富的供应链专家组成。他们拥有深厚的行业知识和专业技能，致力于为客户提供卓越的服务。",
    teamMembers: [
        {
            name: "张三",
            title: "首席执行官",
            bio: "张三先生在供应链管理领域拥有超过20年的经验，曾成功领导多个大型国际项目。",
            imageUrl: "https://placehold.co/150x150/a7d9ff/007bff?text=CEO"
        },
        {
            name: "李四",
            title: "运营总监",
            bio: "李四女士精通国际物流和仓储管理，擅长优化运营流程，提升效率。",
            imageUrl: "https://placehold.co/150x150/a7d9ff/007bff?text=COO"
        },
        {
            name: "王五",
            title: "市场总监",
            bio: "王五先生在市场拓展和客户关系维护方面表现出色，为公司带来了众多战略合作伙伴。",
            imageUrl: "https://placehold.co/150x150/a7d9ff/007bff?text=CMO"
        }
    ],
    coreAdvantages: [
        {
            title: "全球网络",
            points: [
                "覆盖亚洲、欧洲、北美等主要经济区域。",
                "与多家国际知名物流公司建立长期合作关系。",
                "提供多式联运解决方案。"
            ]
        },
        {
            title: "技术驱动",
            points: [
                "自主研发的供应链管理系统，实现全程可视化。",
                "大数据分析和AI预测，优化库存和运输。",
                "区块链技术保障数据安全和透明。"
            ]
        },
        {
            title: "专业团队",
            points: [
                "拥有国际认证的供应链管理师团队。",
                "熟悉各国贸易政策和法规。",
                "提供定制化解决方案和专业咨询。"
            ]
        }
    ]
};

// 默认业务与展望内容
export const defaultBusinessOutlookContent = {
    businessScopeItems: [
        {
            title: "国际货运代理",
            text: "提供海运、空运、陆运等多种国际货运代理服务，确保货物安全、准时送达。",
            imageUrl: "https://placehold.co/400x250/a7d9ff/007bff?text=Freight+Forwarding"
        },
        {
            title: "仓储与配送",
            text: "拥有现代化仓储设施，提供专业的仓储管理、分拣、包装和末端配送服务。",
            imageUrl: "https://placehold.co/400x250/a7d9ff/007bff?text=Warehousing"
        },
        {
            title: "供应链金融",
            text: "与金融机构合作，为客户提供灵活的供应链金融解决方案，缓解资金压力。",
            imageUrl: "https://placehold.co/400x250/a7d9ff/007bff?text=Supply+Chain+Finance"
        }
    ],
    businessExpansionItems: [
        {
            title: "拓展新兴市场",
            points: [
                "积极布局东南亚、非洲等新兴市场，拓展业务覆盖范围。",
                "建立本地化运营团队，提供更贴近市场的服务。"
            ]
        },
        {
            title: "深化技术应用",
            points: [
                "加大研发投入，升级智能供应链管理平台。",
                "探索物联网、人工智能在供应链中的应用，提升运营效率。"
            ]
        }
    ],
    financialForecast: {
        revenueTable: [
            { year: "2023", revenue: 50, sales: 45, grossProfit: 5 },
            { year: "2024E", revenue: 70, sales: 60, grossProfit: 10 },
            { year: "2025E", revenue: 100, sales: 85, grossProfit: 15 }
        ],
        costAssumptions: [
            {
                type: "运输成本",
                details: [
                    "燃油价格稳定，运输效率提升。",
                    "与承运商签订长期合作协议，锁定成本。"
                ]
            },
            {
                type: "仓储成本",
                details: [
                    "仓库自动化水平提高，人工成本降低。",
                    "优化库存周转率，减少滞销库存。"
                ]
            }
        ],
        investmentOpportunity: "我们预计未来三年业务将持续高速增长，欢迎有志之士和投资机构与我们携手共创辉煌。"
    }
};

// 默认行业动态内容 (新闻格式)
export const defaultIndustryDynamicsContent = {
    newsItems: [
        {
            id: 'news-20240717-001',
            title: "全球供应链韧性增强，中国贡献凸显",
            date: "2024-07-17",
            media: "新华网",
            content: "最新报告显示，在全球经济不确定性增加的背景下，全球供应链的韧性正在逐步增强。其中，中国作为全球制造业中心，在稳定供应链方面发挥了关键作用，其强大的生产能力和完善的物流网络为全球经济复苏提供了有力支撑。未来，数字化和绿色化将成为供应链发展的重要趋势。"
        },
        {
            id: 'news-20240715-002',
            title: "RCEP生效两年：区域经济一体化加速",
            date: "2024-07-15",
            media: "人民日报",
            content: "《区域全面经济伙伴关系协定》（RCEP）生效两年来，成员国之间的贸易投资合作不断深化，区域经济一体化进程显著加速。关税减让、原产地累积规则等政策红利持续释放，极大地促进了区域内供应链的优化和融合，为企业带来了新的发展机遇。"
        },
        {
            id: 'news-20240710-003',
            title: "智能仓储技术引领物流行业新变革",
            date: "2024-07-10",
            media: "物流时报",
            content: "随着人工智能、物联网等技术的快速发展，智能仓储正成为物流行业转型升级的重要方向。自动化立体仓库、AGV（自动导引车）、机器人分拣系统等智能设备的应用，大幅提升了仓储效率和准确性，有效降低了运营成本，为企业构建高效供应链提供了强大支持。"
        }
    ]
};

// 默认联系信息
export const defaultContactInfo = {
    phone: "+86-XXXXXXXXXX",
    email: "info@hezhengscm.com",
    address: "中国广东省广州市天河区XXXX路XXXX号"
};
